module.exports = __webpack_public_path__ + "static/img/面向对象设计bg.cb1a0adb.png";